"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconPinPoint = void 0;
var react_1 = __importDefault(require("react"));
var pointColors = {
    black: 'black',
    blue: '#0073fa',
    green: '#00d896',
    white: 'white'
};
var IconPinPoint = function (_a) {
    var pointIndex = _a.pointIndex, _b = _a.colors, colors = _b === void 0 ? { label: 'white', pin: 'black' } : _b, props = __rest(_a, ["pointIndex", "colors"]);
    return (react_1.default.createElement("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 16 21", fill: pointColors[colors.pin], xmlns: "http://www.w3.org/2000/svg" }, props),
        react_1.default.createElement("path", { d: "M8.53767 0C13.0199 0 17.0753 3.43641 17.0753 8.75111C17.0753 12.1448 14.4607 16.1362 9.24203 20.7359C8.83649 21.088 8.22818 21.088 7.82264 20.7359C2.61466 16.1362 0 12.1448 0 8.75111C0 3.43641 4.05539 0 8.53767 0Z", fill: pointColors[colors.pin] }),
        react_1.default.createElement("text", { x: "50%", y: "50%", alignmentBaseline: "middle", className: 'small', textAnchor: "middle", fill: pointColors[colors.label] || 'white', fontSize: "12", fontWeight: 'bold' }, pointIndex)));
};
exports.IconPinPoint = IconPinPoint;
